import {FC, useState, useEffect, Fragment} from 'react'

import {Modal} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import {toast} from 'react-toastify'
const api = new Api()

type Props = {
  showAlertModal: boolean
  handleCloseAlertModal: any
  type: string
  title: string
  desc: string
  buttonText: string
  data: any
  handleReload: any
}

const AlertContent: FC<Props> = ({
  showAlertModal,
  handleCloseAlertModal,
  type,
  title,
  desc,
  buttonText,
  data,
  handleReload,
}) => {
  const navigate = useNavigate()
  const [showModal, setShowModal] = useState<any>(false)
  const [loading, setLoading] = useState(false)
  const [errors, setErrors] = useState<any>({})
  const [dataForm, setDataForm] = useState<any>({})

  useEffect(() => {
    setShowModal(showAlertModal)
  }, [showAlertModal])

  const handleClose = () => {
    setShowModal(false)
    handleCloseAlertModal()
    setErrors({})
    setDataForm({})
  }

  const action = () => {
    setLoading(true)

    let apiAction
    if (type == 'approve') {
      apiAction = api.approveProfile(data?.id)
    } else if (type == 'archive') {
      apiAction = api.archiveProfile(data?.id)
    } else if (type == 'delete') {
      apiAction = api.deleteProfile(data?.id)
    } else if (type == 'star') {
      apiAction = api.staredProfile(data?.id)
    } else {
      apiAction = api.rejectProfile(data?.id, dataForm)
    }

    apiAction
      .then((response: any) => {
        setLoading(false)
        const {data} = response
        toast.success(data?.meta?.message ?? data?.message)
        setShowModal(false)
        handleReload(true)
      })
      .catch((error: any) => {
        setLoading(false)
        const {data} = error.response
        toast.error(data?.meta?.message)
        setErrors(data?.meta?.error)
      })
  }

  return (
    <Modal show={showModal} centered size={`${type == 'reject' ? 'lg' : 'sm'}`}>
      <div className='p-10'>
        <p className='h6 text-center'>{title}</p>

        <p className='mt-3'>{desc}</p>

        {type == 'reject' && (
          <>
            <p className='mt-8'>Alasan</p>
            <textarea
              onChange={(e) => setDataForm({rejected_reason: e.target.value})}
              className={`form-control ${errors?.rejected_reason && 'border-danger'}`}
            ></textarea>

            {errors?.rejected_reason ? (
              <p className='text-danger mt-1'>{errors?.rejected_reason}</p>
            ) : null}
          </>
        )}

        <button
          className='btn btn-primary btn-sm w-100 mt-10'
          style={{background: 'var(--Primary-L-500, #F95E2F)'}}
          onClick={action}
          disabled={loading}
        >
          {loading == true ? 'Loading...' : buttonText}
        </button>

        <button
          className='btn btn-sm w-100 mt-3 text-primary'
          style={{border: '1px solid var(--Primary-L-500, #F95E2F)'}}
          onClick={handleClose}
          disabled={loading}
        >
          Batal
        </button>
      </div>
    </Modal>
  )
}

const AlertModal: FC<Props> = ({
  showAlertModal,
  handleCloseAlertModal,
  type,
  title,
  desc,
  buttonText,
  data,
  handleReload,
}) => {
  return (
    <AlertContent
      showAlertModal={showAlertModal}
      handleCloseAlertModal={handleCloseAlertModal}
      type={type}
      title={title}
      desc={desc}
      buttonText={buttonText}
      data={data}
      handleReload={handleReload}
    />
  )
}

export default AlertModal
